import { useState } from 'react'
import { cn } from '~/shared/lib/cn'
import { pluralize } from '~/shared/lib/pluralize'
import { Button } from '~/shared/ui'
import { LONG_TEXT_CHARS, LONG_TEXT_LINES } from '../config'
import { countLines } from '../lib'

export function LongText({ text, mono = false }: { text: string; mono?: boolean }) {
  const [isExpanded, setIsExpanded] = useState(false)
  const lines = countLines(text)
  const isLong = text.length > LONG_TEXT_CHARS || lines > LONG_TEXT_LINES

  return (
    <div className="flex flex-col items-start gap-1">
      <pre
        className={cn(
          'm-0 w-full wrap-anywhere whitespace-pre-wrap',
          mono ? 'font-mono text-[12px] leading-5' : 'font-[inherit] text-[13px] leading-5',
          { 'max-h-60 overflow-hidden': isLong && !isExpanded },
        )}
      >
        {text}
      </pre>
      {isLong && (
        <Button
          size="small"
          onClick={() => setIsExpanded((expanded) => !expanded)}
        >
          {isExpanded
            ? 'Show less'
            : `Show all (${lines.toLocaleString('en-US')} ${pluralize(lines, 'line')})`}
        </Button>
      )}
    </div>
  )
}
